import React, { Component } from 'react';
import { Breadcrumb } from '@blueprintjs/core'
import aboutImage from '../assets/about_1.jpg'
import createHistory from 'history/createBrowserHistory'
import { Router } from 'react-router-dom'
import ReactGA from 'react-ga'



const aboutStyles = {
    width: "90%",
    margin: "20px auto",
    border: "1px solid #ddd",
    borderRadius: "5px",
    padding: "10px"
};
const aboutImageStyle= {
    float: "right",
    margin:"0px 5px 5pxpx 5px",
    height: "250px"
}
class About extends Component {

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }


    render() {
        return (
            <div>
                <ul className="pt-breadcrumbs">
                    <li><Breadcrumb href="/home" text="Home" /></li>
                    <li><Breadcrumb href="/about" text="About" /></li>
                </ul>
                <hr />
                <div>
                    <h3>About Forrest</h3>
                    <div style={aboutStyles}>
                    <div style={{clear:'both'}}>
                    <img  style={aboutImageStyle} src={aboutImage}></img>
                        <p>
                        Born and raised in Ohio for the majority of my life; I became interested in computers from a very young age.
                            Often pulling apart computers just to see what was inside, I eventually began to discover the immerse power these machines had and began writing simple dos programs.
                            Through my childhood and into high school I worked on computers and was eventually hired at Toast.net Internet Service Provider my sophomore year Of High School.                
                        </p>
                        <p>
                            While at Toast.net, I was mentored by Kevin David.  It was under his guidance that I  began to sharpen my technology and communication skills.  I learned basic, vB, and relational-database schema
                            along with everything under the sun about TCP/IP.  This peaked my interest in technology and confirmed what I expected as a child that computers would be the future and I had to be a part of it.  
                            Without this time under Kevin's mentorship I would not have continued my path on technology into College at Xavier in Cincinnati.
                        </p>
                        <p>
                            After college I moved to Seattle to work for Liberty Mutual Insurance Group where I am currently the  Lead Developer for our Book Transfer team.
                            Thought my career at Liberty I have become fluent in Java, Angular, React, SQL, and noSQL.  I am also proficient in .net and vB.
                            Along with my day job, I design websites for fun and am currently in opment on several apps.  Check out the Projects section for more infornation. And feel free to contact me if you would like to work together!
                            </p>
                            </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.jsx